import React, { ReactElement } from 'react';

export type ExternalLinkProps = {
  children: (ReactElement | string)[] | ReactElement | string;
  href: string;
  className?: string;
  openNewWindow?: boolean;
};

const ExternalLink: React.FC<ExternalLinkProps> = ({
  children,
  href,
  className = '',
  openNewWindow = false,
}: ExternalLinkProps) => {
  const classes = `${className} link-input text-sm`;
  const target = openNewWindow ? '_blank' : '_top';

  return (
    <a className={classes} href={href} target={target}>
      {children}
    </a>
  );
};

export default ExternalLink;
